import {createAtom, makeAutoObservable, entries} from 'mobx'; //reaction,
import {APIClient} from '../api/client';
import {Settings} from './settings';
import { WebsocketClient } from "../api/ws-client";
import RecordRTC from 'recordrtc';
import { MIDI } from './midi'

import * as Tone from 'tone';


let _snackBarId = 0;

if (process.env.NODE_ENV !== 'production') {
  window._client = APIClient;
}

export class Store {
  constructor() {
    this.user = null;
    this.usersMap = {};
    this.workshops = [];
    this.workshopCode = null;
    this.roomCode = "";
    this.selectedRoom = null;
    this.snackbars = [];
    this.sounds = [];
    this.soundsLoaded = [];
    this.onAir = false;
    this.canChangeOnAirStatus = true;
    this.deviceId = this.readCookie("device_uuid");
    this.csrfToken = null;
    console.log(this.deviceId)

    this.websocketClient = null;

    this._subscribeToAPIClientEvents();
    makeAutoObservable(this);

    this.settings = new Settings();
    this.midi = new MIDI(this)
    this.settings.restore();
    this.checkIsStaff()
    let port = '';
    if (this.settings.server.port !== 80 || this.settings.server.port !== 443) {
      port = this.settings.server.port;
    }
    const portToUse = port !== "" ? `:${port}` : '';
    const serverAddress = this.settings.server.url;
    const baseUrl = `${serverAddress}${portToUse}`;
    const ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
    this.socket_ws_path = ws_scheme + "://".concat(baseUrl).concat("/ws/chat/");

    this._settingsAtom = createAtom('settings');
    this.settings.onSave = () => {
      this._settingsAtom.reportChanged();
    };

    this.updateClientSettings();

    this.isStaff = false;

    window.addEventListener('pagehide', (e) => !e.persisted && this.dispose(), false);
  }


  _subscribeToAPIClientEvents() {
    APIClient.on_users_map_change = ({ users_map }) => {
      this.usersMap = users_map;
    };
  }

  updateClientSettings() {
    if (!APIClient._cloud_client || APIClient._cloud_server_url !== this.settings.server.url) {
      let tss = this.settings.server;
      APIClient.init_rpc_client(tss.url, tss.port, tss.protocol);
    }
  }

  get workshopCodeOk() {
    return this.workshopCode !== null;
  }

  set workshopCodeOk(o) {
    this.workshopCode = o;
  }

  get userLoggedIn() {
    return this.user !== null;
  }

  get roomSelected() {
    return this.selectedRoom !== null;
  }

  set deviceIdUpdate(deviceId) {
    this.deviceId = deviceId;
  }

  set csrfTokenUpdate(csrfToken) {
    this.csrfToken = csrfToken;
  }

  get onlineUsers() {
    return entries(this.usersMap).map(([key, user]) => {
      const [country, city] = user.location.split(':');
      return {id: parseInt(key, 10), ...user, country, city};
    });
  }

  connectToRoom(roomId) {
    console.log('connectToRoom', roomId);
    let {rooms} = this.workshops[this.workshopCode]
    this.selectedRoom = rooms.find(room => room.id === roomId);
    const address = this.socket_ws_path.concat(this.workshopCode).concat("/");
    this.websocketClient = new WebsocketClient(address, this);

    this.sendMessage({
      "command": "join",
      "room": roomId
    });

    let soundsToLoad = this.selectedRoom.sounds;
    for (let i = 0; i < soundsToLoad.length; i++) {
      let soundId = soundsToLoad[i].id;

      console.log(soundsToLoad[i].sound_file);
      let tonePlayer = new Tone.Player({
        url: soundsToLoad[i].sound_file,
        onload: () => this.updateSoundsLoaded(soundId),
        onstop: () => this.soundStopped(soundId),
      }).toDestination();
      let soundInfo = {
        id: soundId,
        soundAudio: tonePlayer,
        loading: true,
        playing: false,
        paused: false,
        me: false,
        title:soundsToLoad[i].title,
        playbackMode: soundsToLoad[i].playback_mode, // Add playbackMode property
        pausedAt: 0, // Add pausedAt property
        startTime: 0, // Add startTime property
      }
      this.sounds.push(soundInfo);
    }
    this.onAir = this.selectedRoom.on_air;
  }

  updateSoundsLoaded(i) {
    console.log("soundLoaded: " + i);
    this.soundsLoaded.push({id:i});
    // once all sounds loaded

    let soundsToLoad = this.selectedRoom.sounds;
    let allSoundsLoaded = true;
    for (let i = 0; i < soundsToLoad.length; i++) {
      let soundId = soundsToLoad[i].id;
      let soundLoaded = this.soundsLoaded.find(sound => sound.id === soundId);
      if (!soundLoaded) {
        allSoundsLoaded = false;
        break;
      } else {
        let soundInfo = this.sounds.find(sound => sound.id === soundId)
        soundInfo.loading = false;
      }
    }
    if (allSoundsLoaded) {
      Tone.start().then(_ => {
        console.log("ToneJS started")
      });
    }
  }

  soundStopped(i) {
    let soundInfo = this.sounds.find(sound => sound.id === i)
    if (soundInfo.playing) {
      soundInfo.playing = false;
    }
    if (soundInfo.me) {
      soundInfo.me = false;
    }

    let player = soundInfo.soundAudio;
    const duration = player.buffer ? player.buffer.duration : 0;

    // Calculate playback position
    const playbackPosition = player.toSeconds(
        player.context.currentTime - soundInfo.startTime
    );

    // Determine if playback ended naturally
    if (Math.abs(playbackPosition - duration) < 0.01) {
      if (soundInfo.paused) {
        soundInfo.paused = false;
        soundInfo.pausedAt = 0;
        soundInfo.offset = 0;
      }
    } else {
      if (!soundInfo.paused) {
        soundInfo.offset = 0;
      }
    }
  }

  async checkWorkshopCode(workshop_code) {
    try {
      const response = await APIClient.check_workshop_code(workshop_code);
      this.workshops = [];

      let workshop = {};
      for (const [k, v] of Object.entries(response)) {
        workshop[k] = v;
      }
      this.workshops[workshop_code] = workshop;
      this.settings.workshops = this.workshops;
      this.settings.save();

      // check how many rooms. if only one, set selected Room
      if (this.workshops[workshop_code].rooms.length === 1) {
        this.selectedRoom = this.workshops[workshop_code].rooms[0];
        this.workshopCodeOk = workshop_code;
        this.connectToRoom(this.selectedRoom.id);
      }

      this.workshopCodeOk = workshop_code;

      return true;
    } catch (err) {
      return false;
    }
  }

  async checkIsStaff() {
    try {
      const response = await APIClient.check_is_staff();
      if (response === true) {
        this.isStaff = true;
      }
    } catch (err) {
      this.isStaff = false;
    }
  }

  /*** Snackbar ***/
  showSnackBar(content, {duration = 3000} = {}) {
    const snackbar = {id: _snackBarId++, content};
    this.snackbars.push(snackbar);
    setTimeout(() => {
      this.snackbars = this.snackbars.filter((_snackbar) => _snackbar.id !== snackbar.id);
    }, duration);
  }

  readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  playSound(sId, deviceId) {
    let soundId = parseInt(sId);
    let soundInfo = this.sounds.find(sound => sound.id === soundId);
    let soundLoaded = this.soundsLoaded.find(sound => sound.id === soundId);

    if (deviceId === this.deviceId) {
      let messageDict = {
        "command": "send",
        "room": this.selectedRoom.id,
        "message": "play_" + soundId
      };
      this.sendMessage(messageDict);
      soundInfo.me = true;
    } else {
      soundInfo.playing = true;
    }

    if (soundLoaded) {
      switch (soundInfo.playbackMode) {
        case 'one_shot':
          this.resumeSound(soundId);
          break;
        case 'start_stop':
          this.resumeSound(soundId);
          break;
        case 'start_pause':
          soundInfo.paused = true;
          this.resumeSound(soundId);
          break;
        case 'start_loop_stop':
          soundInfo.soundAudio.loop = true;
          this.resumeSound(soundId);
          break;
        default:
          this.resumeSound(soundId);
      }
    }
  }

  pauseSound(soundId) {
    let soundInfo = this.sounds.find(sound => sound.id === soundId);
    const now = Tone.now();
    soundInfo.pausedAt = now - soundInfo.startTime;
    soundInfo.soundAudio.stop();
    soundInfo.playing = false;
    console.log(`Playback paused at: ${soundInfo.pausedAt} seconds`);
  }

  resumeSound(soundId) {
    let soundInfo = this.sounds.find(sound => sound.id === soundId);
    const now = Tone.now();
    const offset = soundInfo.pausedAt || 0;

    soundInfo.soundAudio.start(now, offset);
    soundInfo.startTime = now - offset;
    soundInfo.playing = true;
    console.log(`Playback started/resumed at: ${offset} seconds`);
  }

  stopSound(sId, deviceId) {
    let soundId = parseInt(sId);
    let soundInfo = this.sounds.find(sound => sound.id === soundId);
    let soundLoaded = this.soundsLoaded.find(sound => sound.id === soundId);

    if (deviceId === this.deviceId) {
      let messageDict = {
        "command": "send",
        "room": this.selectedRoom.id,
        "message": "stop_" + soundId
      };
      this.sendMessage(messageDict);
      soundInfo.me = false;
    } else {
      soundInfo.playing = false;
    }

    if (soundLoaded) {
      switch (soundInfo.playbackMode) {
        case 'start_stop':
          soundInfo.soundAudio.stop();
          break;
        case 'start_pause':
          this.pauseSound(soundId);
          break;
        case 'start_loop_stop':
          soundInfo.soundAudio.stop();
          break;
        default:
          soundInfo.soundAudio.stop();
      }
    }
  }

  processMessage(message) {
    // Decode the JSON
    console.log("Got websocket message " + message.data);
    let data = JSON.parse(message.data);

    // Handle errors
    if (data.error) {
      this.showSnackBar(data.error + ", try refreshing the browser");

      return;
    }

    // Handle joining
    if (data.join) {
      console.log("Joining room " + data.join);
      // Handle leaving
    } else if (data.leave) {
      console.log("Leaving room " + data.leave);
      // Handle getting a message
      } else if (data.message || data.msg_type !== 0) {
        // let ok_msg = "";
        // msg types are defined in chat/settings.py
        // Only for demo purposes is hardcoded, in production scenarios, consider call a service.
        switch (data.msg_type) {
          case 0:
            // Message

            if (data.message.indexOf('play_') !== -1) {
              let soundId = data.message.substring(5);
              console.log("Got play " + soundId + " message");

              // this in this context is the socket, not the store, so use parent
              if (data.device !== this.deviceId) {
                this.playSound(soundId, data.device);
              }
            }

            if (data.message.indexOf('stop_') !== -1) {
              let soundId = data.message.substring(5);
              console.log("Got stop " + soundId + " message");

              // this in this context is the socket, not the store, so use parent
              if (data.device !== this.deviceId) {
                this.stopSound(soundId, data.device);
              }
            }

            if (data.message.indexOf('pause_') !== -1) {
              let soundId = data.message.substring(5);
              console.log("Got pause " + soundId + " message");

              // this in this context is the socket, not the store, so use parent
              if (data.device !== this.deviceId) {
                this.pauseSound(soundId, data.device);
              }
            }

            if (data.message.indexOf('onair_') !== -1 && data.device !== this.deviceId) {
              this.onAir = data.message === "onair_true";

            }

            if (data.message.indexOf('button_press_') !== -1) {
              let buttonPressData = JSON.parse(data.message.substring(13));
              console.log("Got button press message", buttonPressData);
              // Handle button press data
            }

            break;

              case 6:
              //MIDI message
              console.log('Received MIDI Message', data)

              if(data.midi_data)
                this.midi.sendMIDIMessageOut(data.midi_data)
              break
          default:
            console.log("Unsupported message type!");
            return;
        }
        // msgdiv.append(ok_msg);

        // msgdiv.scrollTop(msgdiv.prop("scrollHeight"));
    } else {
      console.log("Cannot handle message!");
    }
  }

  toggleOnAir() {
    this.onAir = !this.onAir;
    this.sendOnAir(this.onAir, this.deviceId)
  }

  sendOnAir(onAir, deviceId) {
    if (deviceId === this.deviceId) {
      let messageDict = {
        "command": "send",
        "room": this.selectedRoom.id,
        "message": "onair_" + onAir
      };
      this.sendMessage(messageDict);
    }
  }

  sendMessage(messageDict) {
    messageDict.device = this.readCookie("device_uuid");
    this.websocketClient.send(JSON.stringify(messageDict));
  }

  startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.recorder = new RecordRTC(stream, {
        type: 'audio',
        mimeType: 'audio/mp3'
      });
      this.recorder.startRecording();
      // this.isRecording = true;
    }).catch(error => {
      console.error("Error starting recording:", error);
    });
  }

  stopRecording() {
    this.recorder.stopRecording(() => {
      // const blob = this.recorder.getBlob();
      // Save or send the recorded audio data
      // this.isRecording = false;
    });
  }

  // trackButtonPress(deviceNumber, timestamp) {
  //   const buttonPressData = {
  //     deviceNumber,
  //     timestamp
  //   };
  //   const messageDict = {
  //     command: "send",
  //     room: this.selectedRoom.id,
  //     message: "button_press_" + JSON.stringify(buttonPressData)
  //   };
  //   this.sendMessage(messageDict);
  // }
}
